import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { GpfHistoryState } from "@reducers/types/HRM/gpf-history-state";

import { getGpfHistoryRequest } from "@actions/HRM/gpfHistory/gpf-history-actions";
import { getGpfHistoryState } from "@selectors/HRM/gpfHistory/gpf-history-selector";

import { useAppSelector } from "@helpers/redux";
import { GpfHistoryType } from "@type/HRM/gpf-history";

interface UseGpfHistory {
  gpfHistoryRequest: boolean;
  gpfHistorySuccess: boolean;
  gpfHistoryFailed: boolean;
  gpfHistory: GpfHistoryType[];
}

export const useGpfHistory = (id: number | null): UseGpfHistory => {
  const getGpfHistory = useAppSelector<GpfHistoryState>(getGpfHistoryState);

  const gpfHistoryRequest = getGpfHistory.request as boolean;
  const gpfHistorySuccess = getGpfHistory.success as boolean;
  const gpfHistoryFailed = getGpfHistory.failed as boolean;

  const gpfHistory = getGpfHistory.data || [];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getGpfHistoryRequest(id));
  }, [dispatch, id]);

  return {
    gpfHistoryRequest,
    gpfHistorySuccess,
    gpfHistoryFailed,
    gpfHistory,
  };
};
